import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

export interface FarmInfo {
  location: string;
  cropType: string;
  soilType: string;
  farmSize: string;
  irrigationMethod: string;
}

export interface Recommendation {
  title: string;
  description: string;
  icon?: string;
  tags: string[];
}

export interface DetectionResult {
  disease: string;
  confidence: number;
  description: string;
  treatment: string[];
  preventionMeasures: string[];
  imageUrl?: string;
}

export const farmingPracticesService = {
  async getRecommendations(farmInfo: FarmInfo): Promise<Recommendation[]> {
    if (!API_URL) {
      throw new Error('Farming practices backend is not configured (VITE_API_URL is missing).');
    }
    try {
      const response = await axios.post(`${API_URL}/farming-practices/recommendations`, farmInfo);
      return response.data;
    } catch (error) {
      console.error('Error fetching recommendations:', error);
      throw error;
    }
  },

  async detectDisease(imageFile: File): Promise<DetectionResult> {
    if (!API_URL) {
      throw new Error('Farming practices backend is not configured (VITE_API_URL is missing).');
    }
    try {
      const formData = new FormData();
      formData.append('image', imageFile);

      const response = await axios.post(`${API_URL}/farming-practices/detect-disease`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      console.error('Error detecting disease:', error);
      throw error;
    }
  }
};
